<template>
  <div class="nselectbox " style="padding: 10px 20px 0 20px;">
    <div class="isdie" v-if="$store.state.cause.invaild == 1"></div>
    <div class="ntable table" style=" padding: 0px;">
      <table cellpadding="0" cellspacing="0" class="operation-table">
        <thead>
          <td :width='i.cause_type == 1 ? 25 : 35'>{{ i.cause_type == 1 ? '原告' : '申请人' }}</td>
          <td width='135'> {{ $common.getTypeDisplay(carlist, '名称', '姓名', '名称/姓名') }}</td>
          <td width='100'> {{ $common.getTypeDisplay(carlist, '统一社会信用代码', '身份证号码', '统一社会信用代码/身份证号码') }} </td>
          <td width='63'>联系方式</td>
          <td width='160'> {{ $common.getTypeDisplay(carlist, '注册地', '户籍地', '注册地/户籍地') }}</td>
          <td width='160'> {{ $common.getTypeDisplay(carlist, '办公地', '常住地', '办公地/常住地') }}</td>
          <td width='80' class="operation-col" v-if="display">操作</td>
          <td width='50' class="operation-col" v-if="!display && justlook">操作</td>
        </thead>
        <tbody>
          <tr v-for='(j, ind) in carlist' :key='ind'>
            <td>{{ ind + 1 }}</td>
            <td>
              <div>{{ j.realname }}</div>
            </td>
            <td>
              <div>{{ j.chinaid }}</div>
            </td>
            <td>
              <div>{{ j.phone ? j.phone : '/' }}</div>
            </td>
            <td>
              <div style="width:100%;">
                <Normap :tit='j.registered_address' v-if="j.registered_address"></Normap>
                <Normap :tit="j.province ? (j.province + j.city + j.area + (j.addr || '')) : ''" v-else>
                </Normap>
              </div>
            </td>
            <td>
              <div style="width:100%;">
                <Normap :tit='j.office_address' v-if="j.office_address"></Normap>
                <Normap
                  :tit="j.dwell_province ? (j.dwell_province + j.dwell_city + j.dwell_area + (j.dwell_addr || '')) : ''"
                  v-else>
                </Normap>
              </div>
            </td>
            <td class="operation-col" v-if="display">
              <div class="operation-btn-group">
                <a href='javascript:void(0);' @click='liteCar(j, true, 1)'
                  v-if='$common.AccAUTH(debInfo.accuser_id, "case:debtorCar:index")'>查看</a>
                <a href='javascript:void(0);' @click='liteCar(j, false, 1)'
                  v-if='$common.AccAUTH(debInfo.accuser_id, "case:debtorCar:edit")'
                  :disabled='j.audit.length != 0'><span class="line"></span>修改</a>
                <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='del(j)'
                  v-if='$common.AccAUTH(debInfo.accuser_id, "debtor:other:del") && j.is_main != 1'>
                  <a href="javascript:void(0);" style="color:#f00;" :disabled='j.audit.length != 0'
                    :class='{ "ising": j.audit.length != 0 }'>删除</a>
                </a-popconfirm>
              </div>
            </td>
            <td class="operation-col" v-if="!display && justlook">
              <div class="operation-btn-group">
                <a href='javascript:void(0);' @click='liteCar(j, true, 1)'
                  v-if='$common.AccAUTH(debInfo.accuser_id, "case:debtorCar:index")'>查看</a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- <div v-for="(item, index) in 1" :key="index">
        <div class="label" style="min-width: 230px;">
          <div class="strongs">{{ i.cause_type == 1 ? '原告' : '申请人' }} </div>
        </div>
        <div class="boxModule">
          <div class="label" style="width: 335px;">
            <div class="strong">名称：</div>
            <span>{{ '杭州联合农村商业银行股份有限公司彭埠支行' }}</span>
          </div>

          <div class="label" style="width: 280px;">
            <div class="strong">
              统一社会信用代码：</div>
            <span>{{ '913301006998295750' }}</span>
          </div>

          <div class="label" style="width: 80px;">
          </div>
          <div class="label" style="width: 170px;">
            <div class="strong">联系方式：</div>
            <span>{{ 15888888888 }}</span>
          </div>
          <div class="label" style="flex: 1;">
            <div class="strong">注册地：</div>
            <div style="width:70%;">
              <Normap :tit='debInfo.province ? (debInfo.province + debInfo.city + debInfo.area + debInfo.addr) : null'>
              </Normap>
            </div>
          </div>
          <div class="label" style="flex: 1;">
            <div class="strong">办公地：</div>
            <div style="width:70%;">
              <Normap
                :tit='debInfo.dwell_province ? (debInfo.dwell_province + debInfo.dwell_city + debInfo.dwell_area + debInfo.dwell_addr) : null'>
              </Normap>
            </div>
          </div>
          <div style="display: flex;gap: 10px;">
            <a href='javascript:void(0);' @click='liteCar(j, false)'
              v-if='$common.AccAUTH(debInfo.accuser_id, "case:debtorCar:edit")'><span class="line"></span>修改</a>
            <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='delCar(j.id)'
              v-if='$common.AccAUTH(debInfo.accuser_id, "case:debtorCar:delete")'>
              <a href="javascript:void(0);" style="color:#f00;"> <span class="line"></span>删除</a>
            </a-popconfirm>
          </div>
        </div>
      </div> -->
    </div>
    <div class="ntable table" style="padding: 0;">
      <table cellpadding="0" cellspacing="0">
        <thead>
          <td :width='i.cause_type == 1 ? 25 : 35'>{{ i.cause_type == 1 ? '被告' : '被申请人' }}</td>
          <td width='135'> {{ $common.getTypeDisplay(debtorAll, '名称', '姓名', '名称/姓名') }}</td>
          <td width='100'> {{ $common.getTypeDisplay(debtorAll, '统一社会信用代码', '身份证号码', '统一社会信用代码/身份证号码') }} </td>
          <td width='63'>联系方式</td>
          <td width='160'> {{ $common.getTypeDisplay(debtorAll, '注册地', '户籍地', '注册地/户籍地') }}</td>
          <td width='160'> {{ $common.getTypeDisplay(debtorAll, '办公地', '常住地', '办公地/常住地') }}</td>
          <td width='80' class="operation-col" v-if="display">操作</td>
          <td width='50' class="operation-col" v-if="!display && justlook">操作</td>
        </thead>
        <tbody>
          <tr v-for='(j, index) in debtorAll' :key='index'>
            <td>{{ index + 1 }}</td>
            <td>
              <div style="display: flex;align-items: center;gap: 5px;">{{ j.realname }}
              </div>
            </td>
            <td>
              <div>{{ j.chinaid }}</div>
            </td>
            <td>
              <div>{{ j.phone ? j.phone : '/' }}</div>
            </td>
            <td>
              <div style="width:100%;">
                <Normap :tit="j.province ? (j.province + j.city + j.area + (j.addr || '')) : ''">
                </Normap>
              </div>
            </td>
            <td>
              <div style="width:100%;">
                <Normap
                  :tit="j.dwell_province ? (j.dwell_province + j.dwell_city + j.dwell_area + (j.dwell_addr || '')) : ''">
                </Normap>
              </div>
            </td>
            <td class="operation-col" v-if="display">
              <div class="operation-btn-group" style="display: flex;">
                <a href='javascript:void(0);' @click='liteCar(j, true, 2)'
                  v-if='$common.AccAUTH(debInfo.accuser_id, "case:debtorCar:index")'>查看</a>
                <a href='javascript:void(0);' @click='liteCar(j, false, 2)'
                  v-if='$common.AccAUTH(debInfo.accuser_id, "case:debtorCar:edit")'
                  :disabled='j.audit.length != 0'><span class="line"></span>修改</a>
                <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='del(j)'
                  v-if='$common.AccAUTH(debInfo.accuser_id, "debtor:other:del") && j.is_main != 1'>
                  <a href="javascript:void(0);" style="color:#f00;" :disabled='j.audit.length != 0'
                    :class='{ "ising": j.audit.length != 0 }'>删除</a>
                </a-popconfirm>
              </div>
            </td>
            <td class="operation-col" v-if="!display && justlook">
              <div class="operation-btn-group" style="display: flex;">
                <a href='javascript:void(0);' @click='liteCar(j, true, 2)'
                  v-if='$common.AccAUTH(debInfo.accuser_id, "case:debtorCar:index")'>查看</a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <Other ref='Other' :info='OtherInfo'></Other> -->
    <!-- <div class="box" style="margin-top: 20px;">
      <div>
        <div class="label" style="min-width: 200px;">
          <div class="strongs">{{ i.cause_type == 1 ? '被告 1' : '被申请人 1' }} </div>
        </div>
        <div class="boxModule">
          <div class="label" style="width: 335px;">
            <div class="strong">名称：</div>
            <span>{{ '浩韵控股集团有限公司' }}</span>
          </div>

          <div class="label" style="width: 285px;">
            <div class="strong">统一社会信用代码：</div>
            <span>{{ '91330000680745662C' }}</span>
          </div>
          <div class="label" style="width: 170px;">
            <div class="strong">联系方式：</div>
            <span>{{ 15888888888 }}</span>
          </div>
          <div class="label" style="flex: 1;">
            <div class="strong">注册地：</div>
            <div style="width:70%;">
              <Normap :tit='debInfo.province ? (debInfo.province + debInfo.city + debInfo.area + debInfo.addr) : null'>
              </Normap>
            </div>
          </div>
          <div class="label" style="flex: 1;">
            <div class="strong">办公地：</div>
            <div style="width:70%;">
              <Normap
                :tit='debInfo.dwell_province ? (debInfo.dwell_province + debInfo.dwell_city + debInfo.dwell_area + debInfo.dwell_addr) : null'>
              </Normap>
            </div>
          </div>
          <div style="display: flex;gap: 10px;">
            <a href='javascript:void(0);' @click='liteCar(j, false)'
              v-if='$common.AccAUTH(debInfo.accuser_id, "case:debtorCar:edit")'><span class="line"></span>修改</a>
            <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='delCar(j.id)'
              v-if='$common.AccAUTH(debInfo.accuser_id, "case:debtorCar:delete")'>
              <a href="javascript:void(0);" style="color:#f00;"> <span class="line"></span>删除</a>
            </a-popconfirm>
          </div>

        </div>
        <div class="label" style="min-width: 200px;">
          <div class="strongs">{{ i.cause_type == 1 ? '被告 2' : '被申请人 2' }} </div>
        </div>
        <div class="boxModule">
          <div class="label" style="width: 335px;">
            <div class="strong">姓名：</div>
            <span>{{ '张华峰' }}</span>
          </div>
          <div class="label" style="width: 285px;">
            <div class="strong">证件号码：</div>
            <span>{{ 412723200108276816 }}</span>
          </div>
          <div class="label" style="width: 170px;">
            <div class="strong">联系方式：</div>
            <span>{{ 15888888888 }}</span>
          </div>
          <div class="label" style="flex: 1;">
            <div class="strong">户籍地：</div>
            <div style="width:70%;">
              <Normap :tit='debInfo.province ? (debInfo.province + debInfo.city + debInfo.area + debInfo.addr) : null'>
              </Normap>
            </div>
          </div>
          <div class="label" style="flex: 1;">
            <div class="strong">常住地：</div>
            <div style="width:70%;">
              <Normap
                :tit='debInfo.dwell_province ? (debInfo.dwell_province + debInfo.dwell_city + debInfo.dwell_area + debInfo.dwell_addr) : null'>
              </Normap>
            </div>
          </div>
          <div style="display: flex;gap: 10px;">
            <a href='javascript:void(0);' @click='liteCar(j, false)'
              v-if='$common.AccAUTH(debInfo.accuser_id, "case:debtorCar:edit")'><span class="line"></span>修改</a>
            <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='delCar(j.id)'
              v-if='$common.AccAUTH(debInfo.accuser_id, "case:debtorCar:delete")'>
              <a href="javascript:void(0);" style="color:#f00;"> <span class="line"></span>删除</a>
            </a-popconfirm>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { delOther, delclient } from '@/server/debtor'
export default {
  name: 'Basic',
  props: {
    i: Object,
    info: Object,
    justlook: Boolean
    // debtorAll: Array,
  },
  data() {
    return {
      carlist: [],//原告
      carlist1: [],
      display: true,
      debtorAll:[]
    }
  },
  computed: {
    ...mapGetters([
      'debInfo',
      'APIKEY',
    ])
  },
  watch: {
    i: {
      handler(newVal) {
        if (!newVal) return
        if (newVal.parties_new) {
          this.display = false
          this.carlist = newVal.parties_new.plaintiff || []
          this.debtorAll = newVal.parties_new.defendant || []
        } else if (newVal.parties) {
          this.carlist = newVal.parties.plaintiff || []
          this.debtorAll = new Array()
          this.debtorAll = newVal.parties.defendant
        } else {
          this.carlist = []
          this.debtorAll = []
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    uniqueByKey(arr, key) {
      const map = new Map();
      const result = [];
      for (const item of arr) {
        // 若 Map 中无该 key 值，说明是首次出现，加入结果并记录
        if (!map.has(item[key])) {
          map.set(item[key], true);
          result.push(item);
        }
      }
      return result;
    },
    liteCar(j, bool, num) {
      if (this.i.cause_type == 1) {
        j.titles = num === 1 ? '原告' : '被告'
      } else {
        j.titles = num === 1 ? '申请人' : '被申请人'
      }
      j.see = bool;
      this.$emit('update-user', j);
      this.visibleShow("Other");
    },
    visibleShow(name) {
      this.$store.dispatch("openkey", { key: name, by: true })
    },
    del(item) {         //删除关联被告
      delclient({ id: item.id, cause_id: this.i.id }).then(e => {
        // this.$store.dispatch("Debinfo/getInfo", { id: this.$route.params.id })
        this.$message.success({ content: '已提交审核', key: 'updatable' });
        window.history.go(0)
      })
    }
  },
}
</script>
<style lang="less" scoped>
.ising {
  opacity: 0.4;
}

/* 操作列整体右对齐 */
.operation-table .operation-col {
  text-align: left;
  /* 单元格内容右对齐 */
  padding-right: 10px;
  /* 可选：加右侧内边距，避免贴边 */
}

/* 操作按钮容器：确保不换行，且元素紧凑排列 */
.operation-btn-group {
  display: flex;
  /* 弹性布局，让按钮横向排列 */
  flex-wrap: nowrap;
  /* 强制不换行（核心） */
  justify-content: flex-start;
  /* 容器内元素右对齐，配合单元格的text-align */
  align-items: center;
  /* 垂直居中 */
  white-space: nowrap;
  /* 兜底：防止文本换行 */
}

/* 可选：调整按钮之间的分隔线和间距，优化显示 */
.operation-btn-group a {
  margin: 0 4px;
  /* 按钮之间加间距 */
  white-space: nowrap;
  /* 单个按钮文本不换行 */
}

.operation-btn-group .line {
  /* 分隔线样式优化，避免换行影响 */
  display: inline-block;
  width: 1px;
  height: 12px;
  background: #ccc;
  margin: 0 7px 0 0;
  vertical-align: middle;
}

.box {
  display: flex;
  flex-direction: column;
  background: rgb(248, 249, 251);
  padding: 15px 20px;
  gap: 15px;
  margin-bottom: 10px;
}

.boxModule {
  display: flex;
}

.seximg {
  width: 17px;
  height: 17px;
  margin-top: 2px;
}

.strong {
  color: #0e2949;
}

.strongs {
  font-size: 0.875rem;
  font-weight: 600;
  margin: 10px 0;
  color: #1890ff;
}

.label {
  display: flex;
  color: #66707c;
  flex-wrap: nowrap;
  white-space: nowrap;
}
</style>